import { cx } from "shared/utils";
import { useSoftphone } from "./SoftphoneProvider";
import { SOFTPHONE_OVERLAY_Z_CLASS } from "./stacking";

/**
 * Shown when the softphone has reached a terminal error (e.g. token refresh
 * retries exhausted). Gives the user a visible way to reinitialize the
 * Twilio Device instead of silently waiting.
 */
export function ReconnectBanner() {
  const { status, errorMessage, retryRegistration } = useSoftphone();

  if (status !== "error") return null;

  return (
    <div
      role="alert"
      className={cx(
        "fixed left-1/2 top-4 -translate-x-1/2 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-900 shadow-lg",
        SOFTPHONE_OVERLAY_Z_CLASS
      )}
    >
      <p className="font-medium">Voice service disconnected</p>
      <p className="mt-1 text-xs text-red-800">
        {errorMessage ?? "The softphone lost its connection."}
      </p>
      <button
        type="button"
        onClick={retryRegistration}
        className="mt-2 rounded bg-red-600 px-3 py-1 text-xs font-medium text-white"
      >
        Reconnect
      </button>
    </div>
  );
}
